type CustomAnswersType = string | number | boolean | null | undefined;

export type CalendlyWidgetPrefill<T> = {
  customAnswers?: Record<string, CustomAnswersType>;
} & T;

export type CalendlyWidgetProps<T> = {
  url: string;
  resize?: boolean;
  utm?: Record<string, string>;
  parentElement: HTMLElement | null;
  prefill?: CalendlyWidgetPrefill<T>;
};

export type Calendly = {
  initInlineWidget<T>(params: CalendlyWidgetProps<T>): void;
};

export interface IF360Calendly {
  observarReuniaoFoiAgendada<T extends (params: unknown) => void>(
    callback: T
  ): void;
  removerEventoReuniaoAgendada<T extends () => void>(callback: T): void;
  createWidget<T>(
    url: string,
    elementId: string,
    prefill?: CalendlyWidgetPrefill<T>
  ): Promise<void>;
  setupCalendly(): Promise<unknown>;
}

export const f360CalendlyDI = "F360CalendlyDI";
